module.exports = __webpack_public_path__ + "img/legacy-border.75111059.png";